<template>
  <div :class="$style.root">
    <Stepper
      :total="maxQuestion"
      :current="currentStep"
    />
    <template v-if="question">
      <Question :symbols="question.group.symbols" bgColor="#9488c0cc" :masks="correctChoices">
        <template v-slot:default="{ symbolClass, maskClass }" v-if="!isLoading">
          <template v-if="!showAnswer && !readOnly">
            <template v-for="n in 2">
              <span v-if="questionWords[n - 1]" :class="symbolClass">{{ questionWords[n - 1].word.word }}</span>
              <span v-else :class="maskClass"></span>
            </template>
          </template>
          <Anicss
            :enter-active-class="['animated', 'bounceIn']"
            appear
            v-if="!readOnly"
          >
            <template>
              <span v-if="showAnswer">
                <span v-for="word in answerDisplay" :key="word.id" :class="symbolClass">{{ word.word }}</span>
              </span>
            </template>
          </Anicss>
          <template v-if="readOnly">
            <span>
              <span v-for="word in answerDisplay" :key="word.id" :class="symbolClass">{{ word.word }}</span>
            </span>
          </template>
        </template>
      </Question>
      <Choices :aside="aside" :readOnly="readOnly">
        <template v-if="!readOnly">
          <FormWordChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            @click="canSelect ? selectChoice(n) : null"
            :isAnswer="showAnswer ? isCorrectAnswer(n) : null"
          />
        </template>
        <template v-if="readOnly">
          <FormWordChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            :isAnswer="isCorrectAnswer(n)"
          />
        </template>
      </Choices>
      <template v-if="!readOnly">
        <NextButton
          v-if="canProceed"
          @click="submitAnswer"
          :loading="isLoading"
          :disabled="disableNextButton"
        />
      </template>
      <template v-if="readOnly">
        <NextButton
          v-if="canReadNext"
          @click="readNextStep"
          noAni
        />
        <PrevButton
          v-if="canReadPrev"
          @click="readPrevStep"
          noAni
        />
      </template>
    </template>
  </div>
</template>

<script>
import exerciseMixin from '@/mixins/exercise'
import audioMixin from '@/mixins/audio'
import FormWordChoice from './FormWordChoice'
import Anicss from '@/components/Anicss'

const config = {
  type: 'form-word',
}

export default {
  mixins: [exerciseMixin(config)],
  components: {
    FormWordChoice,
    Anicss,
  },
  async created () {
    await this.init()
  },
  computed: {
    questionWords () {
      return this.selects.map(n => this.choices[n])
    },
    answerDisplay () {
      return this.question.group.words
    },
    timeLimit () {
      return this.history.level == '1'
        ? 5000
        : 6000
    },
  },
  methods: {
    selectChoice (n) {
      if (!this.isSelected(n) && this.selects.length >= 2) {
        return
      }
      this.toggleSelect(n)
    },
  },
}
</script>

<style lang="scss" module>
.root {}
</style>
